module.exports = __webpack_public_path__ + "assets/img/LTC019.3920c484.png";